import React, { useEffect ,useRef} from "react";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import { withStyles } from "@material-ui/core/styles";


// core components
import Header from "components/Header/Header.js";
import FooterHome from "components/Footer/FooterHome.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import HeaderLinks from "components/Header/HeaderLinks.js";
import styled from "styled-components";
import axios from "axios"
import styles from "assets/jss/material-kit-react/views/home.js";
import { Link } from "react-router-dom";
import { Button, Tooltip, Accordion, AccordionDetails, AccordionSummary } from "@material-ui/core";
import Countdown from "react-countdown";
import moment from "moment";
import { HelpOutline, ArrowDropDown, Launch } from '@material-ui/icons';
import icoabi from "../ABI/ICO2ABI.json"
import stackabi from "../ABI/STACKABI.json"
import operonstackabi from "../ABI/OPERONSTACKINGABI.json"
import variableabi from "../ABI/VARIABLEABI.json"
import ico2abi from "../ABI/ICO2ABI.json"

import {
  getCurAddr,
} from '../actions/users';
import Web3 from 'web3';
import '@metamask/legacy-web3'
import config from '../config/config';
import { toast } from 'react-toastify';
toast.configure();
let toasterOption = config.toasterOption;
const useStyles = makeStyles(styles);
var mynetwork = config.NETWORKVERSION
const dashboardRoutes = [];
const Icon = styled(props => (
  <div {...props}>
    <div className="minus">-</div>
    <div className="plus">+</div>
  </div>
))`
  & > .plus {
    display: block;
    color: #24272c;
    font-size: 42px;
    background-color: #383b40;
    width: 50px;
    height: 50px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  & > .minus {
    display: none;
    color: #24272c;
    font-size: 42px;
    background-color: #383b40;
    width: 50px;
    height: 50px;
    border-radius: 50%;
    justify-content: center;
    align-items: center;
  }
  .Mui-expanded & > .minus {
    display: flex;
  }
  .Mui-expanded & > .plus {
    display: none;
  }
`;


// Scroll to Top
function ScrollToTopOnMount() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return null;
}

export default function LandingPage(props) {
  const classes = useStyles();
  const timerRef = useRef(null);
  
const HtmlTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: '#fff',
    color: '#646e88',
    maxWidth: 220,
    fontSize: "13px",
    fontFamily: "'Montserrat', sans-serif",
    lineHeight: "20px",
    border: '1px solid #fff',
    boxShadow: '-4px 5px 10px 2px rgb(0 0 0 / 20%)'
  },
}))(Tooltip);
  const [expanded, setExpanded] = React.useState('panel1');

  const handleChangeFaq = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const renderer = ({ days, Month, Year, hours, minutes, seconds, completed }) => {
        if (completed) {
            return <span></span>
        } else {
            return <span>{days}d {hours}h {minutes}m {seconds}s</span>;
        }
    };

  const { ...rest } = props;
  const [accounts, setAccounts]     = React.useState("");
  const [harvestprogress,setharvestprogress] = React.useState(false)
  const [claimprogress,setclaimprogress] = React.useState(false)
  const [apy,setapy] = React.useState(0)
  const [balance,setbalance] = React.useState(0)
  const [amount,setamount] = React.useState(0)
  const [earnamt,setearnamt] = React.useState(0)
  const [inprogress,setinprogress] = React.useState(false)
  const [myallowance,setallowance] = React.useState(0)
  const [stakedamt, setstakedamt] = React.useState(0)
  const [withamount,setwithamount] = React.useState(0)
  const [approveprogress,setapproveprogress] = React.useState(false)
  const [unstakestatus,setunstakestatus] = React.useState(false)
  const [liquitity,setliquitity] = React.useState(0)
  const [Oroprice,setOroprice] = React.useState(0)
  const [timer,settimer] = React.useState(0)
  const [unstakedamt,setunstakedamt] = React.useState(0)
  const [tvlvalue,settvlvalue] = React.useState(0)

//phase 2
  const [harvestprogress2,setharvestprogress2] = React.useState(false)
  const [claimprogress2,setclaimprogress2] = React.useState(false)
  const [apy2,setapy2] = React.useState(0)
  const [balance2,setbalance2] = React.useState(0)
  const [amount2,setamount2] = React.useState(0)
  const [earnamt2,setearnamt2] = React.useState(0)
  const [inprogress2,setinprogress2] = React.useState(false)
  const [myallowance2,setallowance2] = React.useState(0)
  const [stakedamt2, setstakedamt2] = React.useState(0)
  const [withamount2,setwithamount2] = React.useState(0)
  const [approveprogress2,setapproveprogress2] = React.useState(false)
  const [unstakestatus2,setunstakestatus2] = React.useState(false)
  const [liquitity2,setliquitity2] = React.useState(0)
  const [Oroprice2,setOroprice2] = React.useState(0)
  const [timer2,settimer2] = React.useState(0)
  const [unstakedamt2,setunstakedamt2] = React.useState(0)
  const [tvlvalue2,settvlvalue2] = React.useState(0)

   useEffect(() => {
    getinit();
    const interval = setInterval(async() => {
      await gettvlvalue()
      if(localStorage.getItem("address") && localStorage.getItem("address")!=null && localStorage.getItem("address")!=undefined && localStorage.getItem("address")!=""){
        getharvest(localStorage.getItem("address"))
        getharvest2(localStorage.getItem("address"))
        console.log('This will run every second!');
      }
    }, 3000);
    return () => clearInterval(interval);
  }, []);

  async function gettvlvalue(){
    //   const resp = await axios.post(
    //   config.baseurl + `api/tvlvalue`,{page:1}
    // );
    //   console.log(resp,"=================tvlvalue")
    //   if(resp && resp.data && resp.data.data && resp.data.data[0] && resp.data.data[0].totalamount){
    //     settvlvalue(resp.data.data[0].totalamount)
    //   }else{
    //     settvlvalue(0)
    //   }
    let web3 = new Web3(window.ethereum)
      let Contract = new web3.eth.Contract(ico2abi, config.ICOCONTRACT2);
      let balance = await Contract.methods.balanceOf(config.STACKINGCONTRACT).call();
      // console.log(balance,"=========balance")
      if(balance>0){
        let value = balance/1e18;
        settvlvalue(value)
      }else{
        settvlvalue(0)
      }
      let balance2 = await Contract.methods.balanceOf(config.OPERONSTACKING).call();
      // console.log(balance2,"=========balance")
      if(balance2>0){
        let value2 = balance2/1e18;
        settvlvalue2(value2)
      }else{
        settvlvalue2(0)
      }

  }

  async function getinit(){
    try{
      if(localStorage.getItem("orodsfbjyddjsbyy")){
         var curAddr = await getCurAddr();
         if(curAddr == localStorage.getItem("address")){
          setAccounts(curAddr)
          localStorage.setItem("orodsfbjyddjsbyy",'yes');
          localStorage.setItem("address",curAddr);
          // getharvest(curAddr);
         }else{
          localStorage.clear();
          window.location.reload()
         }
      }
      }catch(err){
        
      }
      getapy()
      getliqiuity()
      getfarmliqiuity()
    }

    async function getliqiuity(){
      axios.get('https://api.pancakeswap.info/api/v2/tokens/0x11d1ac5ec23e3a193e8a491a198f5fc9ee715839')
      .then(async(response)=>{
        console.log(response.data.data.price,"========response.data.data.price")
        if(response && response.data && response.data.data && response.data.data.price){
          setOroprice(response.data.data.price)
        }
      })
  }

  async function getfarmliqiuity(){
    if (window.ethereum) {
      var web3 = new Web3(window.ethereum);
      try {
        if (typeof web3 !== 'undefined') {
          var icoContract = new web3.eth.Contract(icoabi, config.ICOCONTRACT);
          var stackcontract = new web3.eth.Contract(stackabi, config.STACKINGCONTRACT);
          var variable1 = await icoContract.methods.balanceOf(config.STACKINGCONTRACT).call();
          var variable2 = await icoContract.methods.totalSupply().call();
          var variable3 = parseFloat(variable1)/parseFloat(variable2);
          var variablecontract = await icoContract.methods.token0().call();
          var newvarcontract = new web3.eth.Contract(variableabi, variablecontract);
          var variablebalance = await newvarcontract.methods.balanceOf(config.ICOCONTRACT).call();
          var quoteTokenBalance = parseFloat(variablebalance)/1000000000000000000; 
          var variable4 = parseFloat(variable3)*parseFloat(quoteTokenBalance)
          var finalliquity = parseFloat(variable4)*2
          setliquitity(finalliquity)
        }
      }catch(err){
        console.log(err,"======================err4")
      }
    }
  }

  async function getapy(){
    console.log("inapy")
    if (window.ethereum) {
      var web3 = new Web3(window.ethereum);
      try {
        if (typeof web3 !== 'undefined') {
          var icoContract = new web3.eth.Contract(icoabi, config.ICOCONTRACT2);
          var stackcontract = new web3.eth.Contract(stackabi, config.STACKINGCONTRACT);
          console.log(stackcontract,"============stackcontrct")
          var apyc =  await stackcontract.methods.OperonAPY().call()
          setapy(apyc/1000000000000)
        }
      }catch(err){
        console.log(err,"======================err4")
      }
    }
  }

  async function connectMetamask(){
    if (window.ethereum) {
      var web3 = new Web3(window.ethereum);
      try {
        if (typeof web3 !== 'undefined') {
        window.ethereum.enable().then(async function() {
        const web3  = new Web3(window.web3.currentProvider)
         if(window.web3.currentProvider.networkVersion == mynetwork){
        if (window.web3.currentProvider.isMetaMask === true) {
          await web3.eth.getAccounts(async function(error, result) {
            setAccounts(result[0]);
            localStorage.setItem("orodsfbjyddjsbyy",'yes');
            localStorage.setItem("address",result[0]);
            getharvest(result[0])

            //phase 2
            getharvest2(result[0])
            window.location.reload()
          })
        }
        }else {
              toast.warning("Please Connect to BNB Network", toasterOption);
        }
        })
        }else{
             toast.warning("Please Add Metamask External", toasterOption);
        }
      }catch(err){}
     }else{
             toast.warning("Please Add Metamask External", toasterOption);
     }
  }

  async function deposit(){
    setinprogress(true)
    if(amount!=null && amount!=undefined && amount!="" && parseFloat(amount)>0 ){
      if(parseFloat(amount)<=parseFloat(balance)){
    if (window.ethereum) {
      var web3 = new Web3(window.ethereum);
      try {
        if (typeof web3 !== 'undefined') {
        window.ethereum.enable().then(async function() {
        const web3  = new Web3(window.web3.currentProvider)
         if(window.web3.currentProvider.networkVersion == mynetwork){
        if (window.web3.currentProvider.isMetaMask === true) {
          await web3.eth.getAccounts(async function(error, result) {
            setAccounts(result[0]);
            localStorage.setItem("orodsfbjyddjsbyy",'yes');
            localStorage.setItem("address",result[0]);
            var icoContract = new web3.eth.Contract(icoabi, config.ICOCONTRACT2);
            var stackcontract = new web3.eth.Contract(stackabi, config.STACKINGCONTRACT);
            var Tamount = await web3.utils.toWei((amount).toString());
             Tamount = await convert(Tamount)
              await stackcontract.methods.deposit(1,Tamount).send({from: result[0]})
             .then(async (deposituccess) => {
              toast.success("Deposited Successfully", toasterOption);
              window.location.reload();
             })
             .catch((errors) => {
              setinprogress(false)
              toast.warning("Failed Tryagain Later", toasterOption);
             })
          })
        }else {
              setinprogress(false)
              toast.warning("Please Connect to BNB Network", toasterOption);
        }
        }else {
              setinprogress(false)
              toast.warning("Please Connect to BNB Network", toasterOption);
        }
        })
        }else{
             setinprogress(false)
             toast.warning("Please Add Metamask External", toasterOption);
        }
      }catch(err){
        setinprogress(false)
        toast.warning("Failed Tryagain Later", toasterOption);
      }
     }else{ 
             setinprogress(false)
             toast.warning("Please Add Metamask External", toasterOption);
     }
    }else{
             setinprogress(false)
             toast.warning("Insufficient Amount", toasterOption);
     }
   }else{
             setinprogress(false)
             toast.warning("Please Enter Valid Amount", toasterOption);
     }
  }

  function convert(n){
      var sign = +n < 0 ? "-" : "",
      toStr = n.toString();
      if (!/e/i.test(toStr)) {
        return n;
      }
      var [lead,decimal,pow] = n.toString()
       .replace(/^-/,"")
       .replace(/^([0-9]+)(e.*)/,"$1.$2")
       .split(/e|\./);
       return +pow < 0
      ? sign + "0." + "0".repeat(Math.max(Math.abs(pow)-1 || 0, 0)) + lead + decimal
      : sign + lead + (+pow >= decimal.length ? (decimal + "0".repeat(Math.max(+pow-decimal.length || 0, 0))) : (decimal.slice(0,+pow)+"."+decimal.slice(+pow)))
    }

  async function getharvest(myadd){
    var web3 = new Web3(window.ethereum);
    if (typeof web3 !== 'undefined') {
      var icoContract = new web3.eth.Contract(icoabi, config.ICOCONTRACT2);
      var bal =  await icoContract.methods.balanceOf(myadd).call()
      console.log(bal,"============mybalace")
      setbalance((parseFloat(bal)/1000000000000000000).toFixed(4))
      console.log((parseFloat(bal)/1000000000000000000).toFixed(4),"============mybalace")
      var allowance = await icoContract.methods.allowance(myadd,config.STACKINGCONTRACT).call()
      setallowance(parseFloat(allowance)/1000000000000000000)
      var stackcontract = new web3.eth.Contract(stackabi, config.STACKINGCONTRACT);
      var pendingamt = await stackcontract.methods.pendingOperon(1,myadd).call();
      var interval = await stackcontract.methods.timeInterval().call()
      setearnamt((parseFloat(pendingamt)/1000000000000000000).toFixed(8))
      var userdet = await stackcontract.methods.userInfo(1,myadd).call();
      console.log(userdet,"===================userdet")
      var resultdata = await JSON.parse(JSON.stringify(userdet))
      if(resultdata && resultdata.amount && resultdata.amount!=null && resultdata.amount!=undefined && resultdata.amount!="" && parseFloat(resultdata.amount)>0){
        setstakedamt((parseFloat(resultdata.amount)/1000000000000000000))
      }else{
        setstakedamt(0)
      }
      if(resultdata && resultdata.unstaked && resultdata.unstaked!=null && resultdata.unstaked!=undefined && resultdata.unstaked!="" && parseFloat(resultdata.unstaked)>0){
        setunstakedamt((parseFloat(resultdata.unstaked)/1000000000000000000))
      }else{
        setunstakedamt(0)
      }
      if(resultdata && resultdata.unstakeUntil && resultdata.unstakeUntil!=null && resultdata.unstakeUntil!=undefined && resultdata.unstakeUntil!="" ){
        // var datee =  moment.unix((parseFloat(resultdata.unstakeUntil))).format("DD MMM YYYY hh:mm a")
        var mydate = new Date(resultdata.unstakeUntil*1000)
        settimer(mydate)
        var a = moment(mydate)
        var b = moment();
        var c = a.diff(b)
        if(parseFloat(c)>0){
          setunstakestatus(true)
        }else{
          setunstakestatus(false)
        }
      }else{
        settimer(0)
        setunstakestatus(false)
      }
    }else{
         toast.warning("Please Add Metamask External", toasterOption);
    }
  }

  async function proceedharvest(){
     setharvestprogress(true)
     if (window.ethereum) {
      var web3 = new Web3(window.ethereum);
      try {
        if (typeof web3 !== 'undefined') {
        window.ethereum.enable().then(async function() {
        const web3  = new Web3(window.web3.currentProvider)
         if(window.web3.currentProvider.networkVersion == mynetwork){
        if (window.web3.currentProvider.isMetaMask === true) {
          await web3.eth.getAccounts(async function(error, result) {
            setAccounts(result[0]);
            localStorage.setItem("orodsfbjyddjsbyy",'yes');
            localStorage.setItem("address",result[0]);
            var icoContract = new web3.eth.Contract(icoabi, config.ICOCONTRACT2);
            var stackcontract = new web3.eth.Contract(stackabi, config.STACKINGCONTRACT);
             await stackcontract.methods.Harvest(1).send({from: result[0]})
             .then(async (successharvest) => {
              setharvestprogress(false)
               toast.success("Harvested Successfully", toasterOption);
               window.location.reload()
             })
             .catch((errors) => {
              setharvestprogress(false)
              toast.warning("Failed TryAgain Later", toasterOption);
             })
            
          })
        }else{
          setharvestprogress(false)
          toast.warning("Please Add Metamask External", toasterOption);
        }
        }else {
            setharvestprogress(false)
            toast.warning("Please Connect to BNB Network", toasterOption);
        }
        })
        }else{
           setharvestprogress(false)
           toast.warning("Please Add Metamask External", toasterOption);
        }
      }catch(err){
        setharvestprogress(false)
        toast.warning("Please Add Metamask External", toasterOption);
      }
     }else{
          setharvestprogress(false)
          toast.warning("Please Add Metamask External", toasterOption);
     }
  }

  async function proceedclaim(){
     setclaimprogress(true)
     if (window.ethereum) {
      var web3 = new Web3(window.ethereum);
      try {
        if (typeof web3 !== 'undefined') {
        window.ethereum.enable().then(async function() {
        const web3  = new Web3(window.web3.currentProvider)
         if(window.web3.currentProvider.networkVersion == mynetwork){
        if (window.web3.currentProvider.isMetaMask === true) {
          await web3.eth.getAccounts(async function(error, result) {
            setAccounts(result[0]);
            localStorage.setItem("orodsfbjyddjsbyy",'yes');
            localStorage.setItem("address",result[0]);
            var icoContract = new web3.eth.Contract(icoabi, config.ICOCONTRACT2);
            var stackcontract = new web3.eth.Contract(stackabi, config.STACKINGCONTRACT);
             await stackcontract.methods.claim(1).send({from: result[0]})
             .then(async (successclaim) => {
              setclaimprogress(false)
               toast.success("UnStaked Successfully", toasterOption);
               window.location.reload()
             })
             .catch((errors) => {
              setclaimprogress(false)
              toast.warning("Failed TryAgain Later", toasterOption);
             })
            
          })
        }else{
          setclaimprogress(false)
          toast.warning("Please Add Metamask External", toasterOption);
        }
        }else {
            setclaimprogress(false)
            toast.warning("Please Connect to BNB Network", toasterOption);
        }
        })
        }else{
           setclaimprogress(false)
           toast.warning("Please Add Metamask External", toasterOption);
        }
      }catch(err){
        setclaimprogress(false)
        toast.warning("Please Add Metamask External", toasterOption);
      }
     }else{
          setclaimprogress(false)
          toast.warning("Please Add Metamask External", toasterOption);
     }
  }

  const amountchange = (e) => {
    console.log(e.target.value,"=========amountchange")
    setamount(e.target.value)
  }

  async function setmax(){

    setamount(parseFloat(balance))
  }

  async function approvefunction(){
    setapproveprogress(true)
     if (window.ethereum) {
      var web3 = new Web3(window.ethereum);
      try {
        if (typeof web3 !== 'undefined') {
        window.ethereum.enable().then(async function() {
        const web3  = new Web3(window.web3.currentProvider)
         if(window.web3.currentProvider.networkVersion == mynetwork){
        if (window.web3.currentProvider.isMetaMask === true) {
          await web3.eth.getAccounts(async function(error, result) {
            setAccounts(result[0]);
            localStorage.setItem("orodsfbjyddjsbyy",'yes');
            localStorage.setItem("address",result[0]);
            var Tamount = await web3.utils.toWei((1000000000000000000).toString());
             Tamount = await convert(Tamount)
            var icoContract = new web3.eth.Contract(icoabi, config.ICOCONTRACT2);
            var stackcontract = new web3.eth.Contract(stackabi, config.STACKINGCONTRACT);
             await icoContract.methods.approve(config.STACKINGCONTRACT,Tamount).send({from: result[0]})
             .then(async (approvesuccess) => {
              setapproveprogress(false)
              toast.success("Approved Successfully", toasterOption);
              window.location.reload()
              })
             .catch((error) => {
              setapproveprogress(false)
              toast.warning("Failed Tryagain Later", toasterOption);
             })
            
          })
        }else{
          setapproveprogress(false)
          toast.warning("Please Connect to BNB Network", toasterOption);
       
        }
        }else {
            setapproveprogress(false)
            toast.warning("Please Connect to BNB Network", toasterOption);
        }
        })
        }else{
           setapproveprogress(false)
           toast.warning("Please Add Metamask External", toasterOption);
        }
      }catch(err){
        setapproveprogress(false)
        toast.warning("Failed Try Again Later", toasterOption);
      }
     }else{
          setapproveprogress(false)
          toast.warning("Please Add Metamask External", toasterOption);
     }
  }

  async function setwithmax(){
    setwithamount(parseFloat(stakedamt))
  }

  const withamountchange = (e) => {
    setwithamount(e.target.value)
  }

  async function withdraw(){
    setinprogress(true)
    if(withamount && withamount!="" && withamount!=null && withamount!=undefined && parseFloat(withamount)>0){
      if(parseFloat(withamount)<=parseFloat(stakedamt)){
     if (window.ethereum) {
      var web3 = new Web3(window.ethereum);
      try {
        if (typeof web3 !== 'undefined') {
        window.ethereum.enable().then(async function() {
        const web3  = new Web3(window.web3.currentProvider)
         if(window.web3.currentProvider.networkVersion == mynetwork){
        if (window.web3.currentProvider.isMetaMask === true) {
          await web3.eth.getAccounts(async function(error, result) {
            setAccounts(result[0]);
            localStorage.setItem("orodsfbjyddjsbyy",'yes');
            localStorage.setItem("address",result[0]);
            var withdrawamt = await web3.utils.toWei((withamount).toString());
             withdrawamt = await convert(withdrawamt)
            var icoContract = new web3.eth.Contract(icoabi, config.ICOCONTRACT2);
            var stackcontract = new web3.eth.Contract(stackabi, config.STACKINGCONTRACT);
            console.log(withdrawamt,"==========withdrawamtwithdrawamtwithdrawamt")
             await stackcontract.methods.withdraw(1,withdrawamt).send({from: result[0]})
             .then(async (success) => {
               toast.success("Withdraw Successfully", toasterOption);
               window.location.reload();
             })
             .catch((errors) => {
              setinprogress(false)
              toast.warning("Failed Try again Later", toasterOption);

             })
            
          })
        }else {
          setinprogress(false)
            toast.warning("Please Connect to BNB Network", toasterOption);
        }
        }else {
          setinprogress(false)
            toast.warning("Please Connect to BNB Network", toasterOption);
        }
        })
        }else{
          setinprogress(false)
           toast.warning("Please Add Metamask External", toasterOption);
        }
      }catch(err){
       setinprogress(false)
       toast.warning("Failed Try again Later", toasterOption);
      }
     }else{
      setinprogress(false)
          toast.warning("Please Add Metamask External", toasterOption);
     }
     }else{
      setinprogress(false)
    toast.warning("Insufficient Balance", toasterOption);
   }
   }else{
    setinprogress(false)
    toast.warning("Please Enter Valid Amount", toasterOption);
   }
  }


  //phase 2

  
  useEffect(() => {
    getinit2();
    const interval2 = setInterval(async() => {
      // await gettvlvalue2()
      if(localStorage.getItem("address") && localStorage.getItem("address")!=null && localStorage.getItem("address")!=undefined && localStorage.getItem("address")!=""){
        getharvest(localStorage.getItem("address"))
        console.log('This will run every second!');
      }
    }, 3000);
    return () => clearInterval(interval2);
  }, []);

  async function gettvlvalue2(){
      const resp = await axios.post(
      config.baseurl + `api/tvlvalue`,{page:1}
    );
      console.log(resp,"=================tvlvalue")
      if(resp && resp.data && resp.data.data && resp.data.data[0] && resp.data.data[0].totalamount){
        settvlvalue2(resp.data.data[0].totalamount)
      }else{
        settvlvalue2(0)
      }
  }

  async function getinit2(){
    try{
      if(localStorage.getItem("orodsfbjyddjsbyy")){
         var curAddr = await getCurAddr();
         if(curAddr == localStorage.getItem("address")){
          setAccounts(curAddr)
          localStorage.setItem("orodsfbjyddjsbyy",'yes');
          localStorage.setItem("address",curAddr);
          getharvest2(curAddr);
         }else{
          localStorage.clear();
          window.location.reload()
         }
      }
      }catch(err){
        
      }
      getapy2()
      getliqiuity2()
      // getfarmliqiuity2()
    }

    async function getliqiuity2(){
      axios.get('https://api.pancakeswap.info/api/v2/tokens/0x11d1ac5ec23e3a193e8a491a198f5fc9ee715839')
      .then(async(response)=>{
        console.log(response.data.data.price,"========response.data.data.price")
        if(response && response.data && response.data.data && response.data.data.price){
          setOroprice2(response.data.data.price)
        }
      })
  }

  async function getfarmliqiuity2(){
    if (window.ethereum) {
      var web3 = new Web3(window.ethereum);
      try {
        if (typeof web3 !== 'undefined') {
          var icoContract = new web3.eth.Contract(icoabi, config.ICOCONTRACT);
          var stackcontract = new web3.eth.Contract(operonstackabi, config.OPERONSTACKING);
          var variable1 = await icoContract.methods.balanceOf(config.OPERONSTACKING).call();
          var variable2 = await icoContract.methods.totalSupply().call();
          var variable3 = parseFloat(variable1)/parseFloat(variable2);
          var variablecontract = await icoContract.methods.token0().call();
          var newvarcontract = new web3.eth.Contract(variableabi, variablecontract);
          var variablebalance = await newvarcontract.methods.balanceOf(config.ICOCONTRACT).call();
          var quoteTokenBalance = parseFloat(variablebalance)/1000000000000000000; 
          var variable4 = parseFloat(variable3)*parseFloat(quoteTokenBalance)
          var finalliquity = parseFloat(variable4)*2
          setliquitity(finalliquity)
        }
      }catch(err){
        console.log(err,"======================err4")
      }
    }
  }

  async function getapy2(){
    console.log("inapy")
    if (window.ethereum) {
      var web3 = new Web3(window.ethereum);
      try {
        if (typeof web3 !== 'undefined') {
          // var icoContract = new web3.eth.Contract(icoabi, config.ICOCONTRACT2);
          var stackcontract = new web3.eth.Contract(operonstackabi, config.OPERONSTACKING);
          console.log(stackcontract,"============stackcontrct")
          var apyc =  await stackcontract.methods.OperonAPY().call()
          setapy2(apyc/1000000000000)
        }
      }catch(err){
        console.log(err,"======================err4")
      }
    }
  }

  async function deposit2(){
    setinprogress2(true)
    if(amount2!=null && amount2!=undefined && amount2!="" && parseFloat(amount2)>0 ){
      if(parseFloat(amount2)<=parseFloat(balance2)){
    if (window.ethereum) {
      var web3 = new Web3(window.ethereum);
      try {
        if (typeof web3 !== 'undefined') {
        window.ethereum.enable().then(async function() {
        const web3  = new Web3(window.web3.currentProvider)
         if(window.web3.currentProvider.networkVersion == mynetwork){
        if (window.web3.currentProvider.isMetaMask === true) {
          await web3.eth.getAccounts(async function(error, result) {
            setAccounts(result[0]);
            localStorage.setItem("orodsfbjyddjsbyy",'yes');
            localStorage.setItem("address",result[0]);
            var icoContract = new web3.eth.Contract(ico2abi, config.ICOCONTRACT2);
            var stackcontract = new web3.eth.Contract(operonstackabi, config.OPERONSTACKING);
            var Tamount = await web3.utils.toWei((amount2).toString());
             Tamount = await convert(Tamount)
              await stackcontract.methods.deposit(0,Tamount).send({from: result[0]})
             .then(async (deposituccess) => {
              toast.success("Deposited Successfully", toasterOption);
              window.location.reload();
             })
             .catch((errors) => {
              setinprogress(false)
              toast.warning("Failed Tryagain Later", toasterOption);
             })
          })
        }else {
              setinprogress(false)
              toast.warning("Please Connect to BNB Network", toasterOption);
        }
        }else {
              setinprogress(false)
              toast.warning("Please Connect to BNB Network", toasterOption);
        }
        })
        }else{
             setinprogress(false)
             toast.warning("Please Add Metamask External", toasterOption);
        }
      }catch(err){
        setinprogress(false)
        toast.warning("Failed Tryagain Later", toasterOption);
      }
     }else{ 
             setinprogress(false)
             toast.warning("Please Add Metamask External", toasterOption);
     }
    }else{
             setinprogress(false)
             toast.warning("Insufficient Amount", toasterOption);
     }
   }else{
             setinprogress(false)
             toast.warning("Please Enter Valid Amount", toasterOption);
     }
  }


  async function getharvest2(myadd){
    var web3 = new Web3(window.ethereum);
    if (typeof web3 !== 'undefined') {
      var icoContract = new web3.eth.Contract(ico2abi, config.ICOCONTRACT2);
      var bal =  await icoContract.methods.balanceOf(myadd).call()
      console.log(bal,"============mybalace")
      setbalance2((parseFloat(bal)/1000000000000000000).toFixed(4))
      console.log((parseFloat(bal)/1000000000000000000).toFixed(4),"============mybalace")
      var allowance = await icoContract.methods.allowance(myadd,config.OPERONSTACKING).call()
      setallowance2(parseFloat(allowance)/1000000000000000000)
      var stackcontract = new web3.eth.Contract(operonstackabi, config.OPERONSTACKING);
      var pendingamt = await stackcontract.methods.pendingOperon(0,myadd).call();
      var interval = await stackcontract.methods.timeInterval().call()
      setearnamt2((parseFloat(pendingamt)/1000000000000000000).toFixed(8))
      var userdet = await stackcontract.methods.userInfo(0,myadd).call();
      console.log(userdet,"===================userdet")
      var resultdata = await JSON.parse(JSON.stringify(userdet))
      console.log(resultdata,"================resultdata");
      if(resultdata && resultdata.amount && resultdata.amount!=null && resultdata.amount!=undefined && resultdata.amount!="" && parseFloat(resultdata.amount)>0){
        setstakedamt2((parseFloat(resultdata.amount)/1000000000000000000))
      }else{
        setstakedamt2(0)
      }
      if(resultdata && resultdata.unstaked && resultdata.unstaked!=null && resultdata.unstaked!=undefined && resultdata.unstaked!="" && parseFloat(resultdata.unstaked)>0){
        setunstakedamt2((parseFloat(resultdata.unstaked)/1000000000000000000))
      }else{
        setunstakedamt2(0)
      }
      if(resultdata && resultdata.unstakeUntil && resultdata.unstakeUntil!=null && resultdata.unstakeUntil!=undefined && resultdata.unstakeUntil!="" ){
        // var datee =  moment.unix((parseFloat(resultdata.unstakeUntil))).format("DD MMM YYYY hh:mm a")
        
        var mydate = new Date(resultdata.unstakeUntil*1000)
        settimer2(mydate)
        var a = moment(mydate)
        var b = moment();
        var c = a.diff(b)
        if(parseFloat(c)>0){
          setunstakestatus2(true)
        }else{
          setunstakestatus2(false)
        }
      }else{
        settimer2(0)
        setunstakestatus2(false)
      }
    }else{
         toast.warning("Please Add Metamask External", toasterOption);
    }
  }

  async function proceedharvest2(){
     setharvestprogress2(true)
     if (window.ethereum) {
      var web3 = new Web3(window.ethereum);
      try {
        if (typeof web3 !== 'undefined') {
        window.ethereum.enable().then(async function() {
        const web3  = new Web3(window.web3.currentProvider)
         if(window.web3.currentProvider.networkVersion == mynetwork){
        if (window.web3.currentProvider.isMetaMask === true) {
          await web3.eth.getAccounts(async function(error, result) {
            setAccounts(result[0]);
            localStorage.setItem("orodsfbjyddjsbyy",'yes');
            localStorage.setItem("address",result[0]);
            var icoContract = new web3.eth.Contract(ico2abi, config.ICOCONTRACT2);
            var stackcontract = new web3.eth.Contract(operonstackabi, config.OPERONSTACKING);
             await stackcontract.methods.Harvest(0).send({from: result[0]})
             .then(async (successharvest) => {
              setharvestprogress2(false)
               toast.success("Harvested Successfully", toasterOption);
               window.location.reload()
             })
             .catch((errors) => {
              setharvestprogress2(false)
              toast.warning("Failed TryAgain Later", toasterOption);
             })
            
          })
        }else{
          setharvestprogress2(false)
          toast.warning("Please Add Metamask External", toasterOption);
        }
        }else {
            setharvestprogress2(false)
            toast.warning("Please Connect to BNB Network", toasterOption);
        }
        })
        }else{
           setharvestprogress2(false)
           toast.warning("Please Add Metamask External", toasterOption);
        }
      }catch(err){
        setharvestprogress2(false)
        toast.warning("Please Add Metamask External", toasterOption);
      }
     }else{
          setharvestprogress2(false)
          toast.warning("Please Add Metamask External", toasterOption);
     }
  }

  async function proceedclaim2(){
     setclaimprogress2(true)
     if (window.ethereum) {
      var web3 = new Web3(window.ethereum);
      try {
        if (typeof web3 !== 'undefined') {
        window.ethereum.enable().then(async function() {
        const web3  = new Web3(window.web3.currentProvider)
         if(window.web3.currentProvider.networkVersion == mynetwork){
        if (window.web3.currentProvider.isMetaMask === true) {
          await web3.eth.getAccounts(async function(error, result) {
            setAccounts(result[0]);
            localStorage.setItem("orodsfbjyddjsbyy",'yes');
            localStorage.setItem("address",result[0]);
            var icoContract = new web3.eth.Contract(ico2abi, config.ICOCONTRACT2);
            var stackcontract = new web3.eth.Contract(operonstackabi, config.OPERONSTACKING);
             await stackcontract.methods.claim(0).send({from: result[0]})
             .then(async (successclaim) => {
              setclaimprogress2(false)
               toast.success("UnStaked Successfully", toasterOption);
               window.location.reload()
             })
             .catch((errors) => {
              setclaimprogress2(false)
              toast.warning("Failed TryAgain Later", toasterOption);
             })
            
          })
        }else{
          setclaimprogress2(false)
          toast.warning("Please Add Metamask External", toasterOption);
        }
        }else {
            setclaimprogress2(false)
            toast.warning("Please Connect to BNB Network", toasterOption);
        }
        })
        }else{
           setclaimprogress2(false)
           toast.warning("Please Add Metamask External", toasterOption);
        }
      }catch(err){
        setclaimprogress2(false)
        toast.warning("Please Add Metamask External", toasterOption);
      }
     }else{
          setclaimprogress2(false)
          toast.warning("Please Add Metamask External", toasterOption);
     }
  }

  const amountchange2 = (e) => {
    console.log(e.target.value,"=========amountchange")
    setamount2(e.target.value)
  }

  async function setmax2(){

    setamount2(parseFloat(balance2))
  }

  async function approvefunction2(){
    setapproveprogress2(true)
     if (window.ethereum) {
      var web3 = new Web3(window.ethereum);
      try {
        if (typeof web3 !== 'undefined') {
        window.ethereum.enable().then(async function() {
        const web3  = new Web3(window.web3.currentProvider)
         if(window.web3.currentProvider.networkVersion == mynetwork){
        if (window.web3.currentProvider.isMetaMask === true) {
          await web3.eth.getAccounts(async function(error, result) {
            setAccounts(result[0]);
            localStorage.setItem("orodsfbjyddjsbyy",'yes');
            localStorage.setItem("address",result[0]);
            var Tamount = await web3.utils.toWei((1000000000000000000).toString());
             Tamount = await convert(Tamount)
            var icoContract = new web3.eth.Contract(ico2abi, config.ICOCONTRACT2);
            var stackcontract = new web3.eth.Contract(operonstackabi, config.OPERONSTACKING);
             await icoContract.methods.approve(config.OPERONSTACKING,Tamount).send({from: result[0]})
             .then(async (approvesuccess) => {
              setapproveprogress2(false)
              toast.success("Approved Successfully", toasterOption);
              window.location.reload()
              })
             .catch((error) => {
              setapproveprogress2(false)
              toast.warning("Failed Tryagain Later", toasterOption);
             })
            
          })
        }else{
          setapproveprogress2(false)
          toast.warning("Please Connect to BNB Network", toasterOption);
       
        }
        }else {
            setapproveprogress2(false)
            toast.warning("Please Connect to BNB Network", toasterOption);
        }
        })
        }else{
           setapproveprogress2(false)
           toast.warning("Please Add Metamask External", toasterOption);
        }
      }catch(err){
        setapproveprogress2(false)
        toast.warning("Failed Try Again Later", toasterOption);
      }
     }else{
          setapproveprogress2(false)
          toast.warning("Please Add Metamask External", toasterOption);
     }
  }

  async function setwithmax2(){
    setwithamount2(parseInt(stakedamt2))
  }

  const withamountchange2 = (e) => {
    setwithamount2(e.target.value)
  }

  async function withdraw2(){
    setinprogress2(true)
    if(withamount2 && withamount2!="" && withamount2!=null && withamount2!=undefined && parseFloat(withamount2)>0){
      if(parseFloat(withamount2)<=parseFloat(stakedamt2)){
     if (window.ethereum) {
      var web3 = new Web3(window.ethereum);
      try {
        if (typeof web3 !== 'undefined') {
        window.ethereum.enable().then(async function() {
        const web3  = new Web3(window.web3.currentProvider)
         if(window.web3.currentProvider.networkVersion == mynetwork){
        if (window.web3.currentProvider.isMetaMask === true) {
          await web3.eth.getAccounts(async function(error, result) {
            setAccounts(result[0]);
            localStorage.setItem("orodsfbjyddjsbyy",'yes');
            localStorage.setItem("address",result[0]);
            var withdrawamt = await web3.utils.toWei((withamount2).toString());
             withdrawamt = await convert(withdrawamt)
            var icoContract = new web3.eth.Contract(ico2abi, config.ICOCONTRACT2);
            var stackcontract = new web3.eth.Contract(operonstackabi, config.OPERONSTACKING);
            console.log(withdrawamt,"==========withdrawamtwithdrawamtwithdrawamt")
             await stackcontract.methods.withdraw(0,withdrawamt).send({from: result[0]})
             .then(async (success) => {
               toast.success("Withdraw Successfully", toasterOption);
               window.location.reload();
             })
             .catch((errors) => {
              setinprogress2(false)
              toast.warning("Failed Try again Later", toasterOption);

             })
            
          })
        }else {
          setinprogress2(false)
            toast.warning("Please Connect to BNB Network", toasterOption);
        }
        }else {
          setinprogress2(false)
            toast.warning("Please Connect to BNB Network", toasterOption);
        }
        })
        }else{
          setinprogress2(false)
           toast.warning("Please Add Metamask External", toasterOption);
        }
      }catch(err){
       setinprogress2(false)
       toast.warning("Failed Try again Later", toasterOption);
      }
     }else{
      setinprogress2(false)
          toast.warning("Please Add Metamask External", toasterOption);
     }
     }else{
      setinprogress2(false)
    toast.warning("Insufficient Balance", toasterOption);
   }
   }else{
    setinprogress2(false)
    toast.warning("Please Enter Valid Amount", toasterOption);
   }
  }

  window.addEventListener('load', (event) => {
    event.preventDefault();
    console.log('addEventListener',event);
    if(window.ethereum) {
      window.ethereum.on('accountsChanged', function (accounts) {
        window.location.reload(false);
        if(timerRef.current) {
          clearTimeout(timerRef.current);
        }
        timerRef.current = setTimeout(() => {
          connectMetamask();
        }, 1000);
      })

      window.ethereum.on('networkChanged', function (networkId) {
        if(networkId == mynetwork){
          window.location.reload(false);
          if(timerRef.current) {
            clearTimeout(timerRef.current);
          }
          timerRef.current = setTimeout(() => {
            connectMetamask();
          }, 1000);
        }
        else {
          connectMetamask();
        }
      })
    }
  })

  return (
    <div>      
      <Header className="header"
        color="transparent"
        routes={dashboardRoutes}
        brand={<img src={require("../assets/images/logo.png")} alt="logo" className="img-fluid" />}
        rightLinks={<HeaderLinks />}
        fixed
        changeColorOnScroll={{
          height: 100,
          color: "dark",
        }}
        {...rest}
      />    
      <ScrollToTopOnMount/>
      <div className="">
        <div className={classes.container}>
          
        </div>
      </div>

      <div className="main padding_top_g">

      <div className="inner_header">
        <div className={classes.container}>

          <GridContainer className="mt-5 align-items-center justify-content-center">
           <GridItem md={4} sm={12} lg={5} data-aos="fade-up" data-aos-duration="2000">
            
              <div className="grid_view_single">
                <div className="WoodBgTop"></div>
                <div className="WoodBgMidd">
                  <h4 className="text-center">Total Value Locked {parseFloat(tvlvalue).toFixed(2)} in ORO</h4>
                  <div className="grid_view_single_first">
                    <div>
                      <h2>ORO</h2>
                      {/*<p>Automatic restaking</p>*/}
                    </div>
                    <div className="icon_section_new">
                    <div className="primer_img">
                    <img src={require("../assets/images/fav.png")} alt="Icon" />
                    </div>
                    
                    </div>
                  </div>
                  <hr />
                  <div className="grid_view_single_second">
                    <div className="d-flex align-items-center justify-content-between mb-3">
                      <p>APY</p>
                      <div className="d-flex align-items-center"><p>{apy}%</p></div>
                    </div>
                    <div className="d-flex align-items-center justify-content-between">
                      <div>
                        <p>Earned</p>
                        <h4>{earnamt}</h4>
                      </div>
                           {earnamt>0?<Button className="harvest_btn disabled_btn" onClick={harvestprogress?"":()=>proceedharvest()}>{harvestprogress?"In Progress":"Harvest"}</Button>
                            : <Button disabled className="harvest_btn disabled_btn">Harvest</Button>}
                    </div>
                    <div className="count_add_btn d-flex align-items-center justify-content-between mb-2">
                      <label className="mb-2">Start Earning</label>
                    </div>

                    <div className="count_add_btn d-flex align-items-center justify-content-between mb-2">
                    <div>UnStaked Amount : {unstakedamt}</div>
                    <div className="d-flex align-items-center">
                    {unstakestatus?
                      <div className="countdown_panel">
                      <div className="countdown_panel_div">
                        <Countdown
                          date={new Date(timer)}
                          autoStart={true}
                          onStart={() => new Date()}
                          renderer={renderer}
                        ></Countdown>
                      </div>
                      </div>
                      :parseFloat(unstakedamt)>0
                      ?
                      <Button className="harvest_btn disabled_btn" onClick={claimprogress?"":()=>proceedclaim()}>{claimprogress?"In Progress":"Claim"}</Button>
                      :
                      ""
                      }
                      </div>
                    </div>

                    <div className="count_add_btn d-flex align-items-center justify-content-between mb-2">
                    <div>Staked Amount : {stakedamt}</div>
                    {parseFloat(stakedamt)>0?
                    <div className="stake_btn_grps">
                    {unstakestatus ?
                      <Button className="primary_btn " disabled>-</Button>
                    :
                    <Button className="primary_btn " data-toggle="modal" data-target="#withdraw_modal">-</Button>
                    }
                    {/* <Button className="primary_btn " data-toggle="modal" data-target="#Tokens_modal">+</Button> */}
                    </div>
                    :
                    ""
                    }
                    </div>
                    {accounts!="" ?
                    parseFloat(myallowance)<=0?
                    // <Button className="primary_btn blue_btn" onClick={approveprogress?"":()=>approvefunction()}>{approveprogress?"In Progress": "Approve Contract"}</Button>
                    <h1></h1>
                    :
                    parseFloat(stakedamt)>0?
                    ""
                    :
                    // <Button className="primary_btn blue_btn"  data-toggle="modal" data-target="#Tokens_modal">Stake</Button>
                    <h1></h1>
                    :
                    <Button className="primary_btn blue_btn" onClick={()=>connectMetamask()}>Connect Wallet</Button>
                    }
                  </div>
                  <hr />
                  <div className="grid_view_single_third">
                    <div className="d-flex align-items-center justify-content-between">
                      <div className="d-flex align-items-center">
                        {/* <Button className="manual_btn"><img src={require("../assets/images/price_refresh_icon.png")} className="mr-2" />Manual</Button>
                        <HtmlTooltip className="tooltip_content"
                          title={
                            <React.Fragment>
                              <p className="tooltip_content">Your trasaction will revert if the price changes unfavourably by more than this percentage</p>
                            </React.Fragment>
                          }
                        >
                          <HelpOutline className="tooltip_icon" />
                        </HtmlTooltip> */}
                      </div>
                      <a className="accordian_link" data-toggle="collapse" href="#collapseExample1" role="button" aria-expanded="false" aria-controls="collapseExample">
                        Details
                      </a>
                    </div>
                    <div className="collapse" id="collapseExample1">
                      <div>
                        {/* <div className="d-flex justify-content-between align-items-center">
                          <h3>Total Liquidity:</h3>
                          <h4>$ {(parseFloat(stakedamt)*parseFloat(Oroprice)).toFixed()>0?(parseFloat(stakedamt)*parseFloat(Oroprice)).toFixed():(parseFloat(stakedamt)*parseFloat(Oroprice)).toFixed(4)}</h4>
                        </div> */}
                        <br></br>
                        <br></br>
                        <div className="d-flex justify-content-between align-items-start">
                          <h3></h3>
                          <div className="text-right">
                            <p><a href={config.CONTRACTURL+config.STACKINGCONTRACT} target="_blank">View Contract <i className="bi bi-box-arrow-up-right"></i></a></p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="WoodBgTop"></div>
              </div>
            </GridItem>

          {/* second phase */}

          <GridItem md={4} sm={12} lg={5} data-aos="fade-up" data-aos-duration="2000">
            
              <div className="grid_view_single">
                <div className="WoodBgTop"></div>
                <div className="WoodBgMidd">
                  <h4 className="text-center">Total Value Locked {parseFloat(tvlvalue2).toFixed(2)} in ORO</h4>
                  <div className="grid_view_single_first">
                    <div>
                      <h2>ORO</h2>
                      {/*<p>Automatic restaking</p>*/}
                    </div>
                    <div className="icon_section_new">
                    <div className="primer_img">
                    <img src={require("../assets/images/fav.png")} alt="Icon" />
                    </div>
                    
                    </div>
                  </div>
                  <hr />
                  <div className="grid_view_single_second">
                    <div className="d-flex align-items-center justify-content-between mb-3">
                      <p>APY</p>
                      <div className="d-flex align-items-center"><p>{apy2}%</p></div>
                    </div>
                    <div className="d-flex align-items-center justify-content-between">
                      <div>
                        <p>Z-ORO Earned</p>
                        <h4>{earnamt2}</h4>
                      </div>
                      {earnamt2>0?
                            <Button className="harvest_btn disabled_btn" onClick={harvestprogress2?"":()=>proceedharvest2()}>{harvestprogress2?"In Progress":"Harvest"}</Button>
                            : <Button disabled className="harvest_btn disabled_btn">Harvest</Button>
                      }
                    </div>
                    <div className="count_add_btn d-flex align-items-center justify-content-between mb-2">
                      <label className="mb-2">Start Earning</label>
                    </div>

                    <div className="count_add_btn d-flex align-items-center justify-content-between mb-2">
                    <div>UnStaked Amount : {unstakedamt2}</div>
                    <div className="d-flex align-items-center">
                    {unstakestatus2?
                      <div className="countdown_panel">
                      <div className="countdown_panel_div">
                        <Countdown
                          date={new Date(timer2)}
                          autoStart={true}
                          onStart={() => new Date()}
                          renderer={renderer}
                        ></Countdown>
                      </div>
                      </div>
                      :parseFloat(unstakedamt2)>0
                      ?
                      <Button className="harvest_btn disabled_btn" onClick={claimprogress2?"":()=>proceedclaim2()}>{claimprogress2?"In Progress":"Claim"}</Button>
                      :
                      ""
                      }
                      </div>
                    </div>

                    <div className="count_add_btn d-flex align-items-center justify-content-between mb-2">
                    <div>Staked Amount : {stakedamt2}</div>
                    {parseFloat(stakedamt2)>0?
                    <div className="stake_btn_grps">
                    {unstakestatus2 ?
                      <Button className="primary_btn " disabled>-</Button>
                    :
                    <Button className="primary_btn " data-toggle="modal" data-target="#withdraw_modal2">-</Button>
                    }
                    <Button className="primary_btn " data-toggle="modal" data-target="#Tokens_modal2">+</Button>
                    </div>
                    :
                    ""
                    }
                    </div>
                    {accounts!="" ?
                    parseFloat(myallowance2)<=0?
                    <Button className="primary_btn blue_btn" onClick={approveprogress2?"":()=>approvefunction2()}>{approveprogress2?"In Progress": "Approve Contract"}</Button>
                    :
                    parseFloat(stakedamt2)>0?
                    ""
                    :
                    <Button className="primary_btn blue_btn"  data-toggle="modal" data-target="#Tokens_modal2">Stake</Button>
                    :
                    <Button className="primary_btn blue_btn" onClick={()=>connectMetamask()}>Connect Wallet</Button>
                    }
                  </div>
                  <hr />
                  <div className="grid_view_single_third">
                    <div className="d-flex align-items-center justify-content-between">
                      <div className="d-flex align-items-center">
                        {/* <Button className="manual_btn"><img src={require("../assets/images/price_refresh_icon.png")} className="mr-2" />Manual</Button>
                        <HtmlTooltip className="tooltip_content"
                          title={
                            <React.Fragment>
                              <p className="tooltip_content">Your trasaction will revert if the price changes unfavourably by more than this percentage</p>
                            </React.Fragment>
                          }
                        >
                          <HelpOutline className="tooltip_icon" />
                        </HtmlTooltip> */}
                      </div>
                      <a className="accordian_link" data-toggle="collapse" href="#collapseExample2" role="button" aria-expanded="false" aria-controls="collapseExample">
                        Details
                      </a>
                    </div>
                    <div className="collapse" id="collapseExample2">
                      <div>
                        {/* <div className="d-flex justify-content-between align-items-center">
                          <h3>Total Liquidity:</h3>
                          <h4>$ {(parseFloat(stakedamt)*parseFloat(Oroprice)).toFixed()>0?(parseFloat(stakedamt)*parseFloat(Oroprice)).toFixed():(parseFloat(stakedamt)*parseFloat(Oroprice)).toFixed(4)}</h4>
                        </div> */}
                        <br></br>
                        <br></br>
                        <div className="d-flex justify-content-between align-items-start">
                          <h3></h3>
                          <div className="text-right">
                            <p><a href={config.CONTRACTURL+config.OPERONSTACKING} target="_blank">View Contract <i className="bi bi-box-arrow-up-right"></i></a></p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="WoodBgTop"></div>
              </div>
            </GridItem>
          </GridContainer>
        </div>
      </div>

        <FooterHome />
           {/*  ROI Modal */}
      <div className="modal fade primary_modal toledbn" data-backdrop="static" id="Tokens_modal" tabIndex="-1" role="dialog" aria-labelledby="roi_modal" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header pt-1 mb-3 position">
              <h5 className="modal-title" id="Tokens_modal">Deposit</h5>
              <button type="button" className="close close_new" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
             <div className="input_panel">
                  <div className="d-flex justify-content-between align-items-center">
                    <label>Bal: {parseFloat(balance).toFixed(6)}</label>
                    </div>  
                    <div className="d-flex justify-content-between align-items-center home_inp_panel">
                      <input type="number"  className="custom_inp" min="0" onChange={amountchange} value={amount}/>
                      <Button className="harvest_btn" onClick={()=>setmax()}>Max</Button>
                    </div>                  
             </div>
             <div className="mt-3 d-flex justify-content-between align-items-center">
               <Button className="primary_btn blue_btn mr-3"  data-dismiss="modal" aria-label="Close">Cancel</Button> 
               <Button className="primary_btn blue_btn" onClick={accounts!=""?()=>deposit():()=>connectMetamask()}>{inprogress ? "In Progress" : "Confirm"}</Button>                       
             </div>
            
            </div>
          </div>
        </div>
      </div>

      {/* phase 2 */}
      <div className="modal fade primary_modal toledbn" data-backdrop="static" id="Tokens_modal2" tabIndex="-1" role="dialog" aria-labelledby="roi_modal" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header pt-1 mb-3 position">
              <h5 className="modal-title" id="Tokens_modal">Deposit</h5>
              <button type="button" className="close close_new" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
             <div className="input_panel">
                  <div className="d-flex justify-content-between align-items-center">
                    <label>Bal: {parseFloat(balance2).toFixed(6)}</label>
                    </div>  
                    <div className="d-flex justify-content-between align-items-center home_inp_panel">
                      <input type="number"  className="custom_inp" min="0" onChange={amountchange2} value={amount2}/>
                      <Button className="harvest_btn" onClick={()=>setmax2()}>Max</Button>
                    </div>                  
             </div>
             <div className="mt-3 d-flex justify-content-between align-items-center">
               <Button className="primary_btn blue_btn mr-3"  data-dismiss="modal" aria-label="Close">Cancel</Button> 
               <Button className="primary_btn blue_btn" onClick={accounts!=""?()=>deposit2():()=>connectMetamask()}>{inprogress ? "In Progress" : "Confirm"}</Button>                       
             </div>
            
            </div>
          </div>
        </div>
      </div>

      <div className="modal fade primary_modal toledbn" data-backdrop="static" id="withdraw_modal" tabIndex="-1" role="dialog" aria-labelledby="roi_modal" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header pt-1 mb-3 position">
              <h5 className="modal-title" id="withdraw_modal">Withdraw</h5>
              <button type="button" className="close close_new" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
             <div className="input_panel">
                  <div className="d-flex justify-content-between align-items-center">
                    <label>Bal: {parseFloat(stakedamt).toFixed(6)}</label>
                    </div>  
                    <div className="d-flex justify-content-between align-items-center home_inp_panel">
                      <input type="number"  className="custom_inp"  onChange={withamountchange}  value={withamount} />
                      <Button className="harvest_btn" onClick={()=>setwithmax()}>Max</Button>
                    </div>                  
             </div>
             <div className="mt-3 d-flex justify-content-between align-items-center">
               <Button className="primary_btn blue_btn mr-3"  data-dismiss="modal" aria-label="Close">Cancel</Button> 
               <Button className="primary_btn blue_btn" onClick={accounts!=""?()=>withdraw():()=>connectMetamask()}>{inprogress ? "In Progress" : "Confirm"}</Button>                       
             </div>
            
            </div>
          </div>
        </div>
      </div>

      {/* phase 2 */}

      <div className="modal fade primary_modal toledbn" data-backdrop="static" id="withdraw_modal2" tabIndex="-1" role="dialog" aria-labelledby="roi_modal" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header pt-1 mb-3 position">
              <h5 className="modal-title" id="withdraw_modal">Withdraw</h5>
              <button type="button" className="close close_new" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
             <div className="input_panel">
                  <div className="d-flex justify-content-between align-items-center">
                    <label>Bal: {parseFloat(stakedamt2).toFixed(6)}</label>
                    </div>  
                    <div className="d-flex justify-content-between align-items-center home_inp_panel">
                      <input type="number"  className="custom_inp"  onChange={withamountchange2}  value={withamount2} />
                      <Button className="harvest_btn" onClick={()=>setwithmax2()}>Max</Button>
                    </div>                  
             </div>
             <div className="mt-3 d-flex justify-content-between align-items-center">
               <Button className="primary_btn blue_btn mr-3"  data-dismiss="modal" aria-label="Close">Cancel</Button> 
               <Button className="primary_btn blue_btn" onClick={accounts!=""?()=>withdraw2():()=>connectMetamask()}>{inprogress2 ? "In Progress" : "Confirm"}</Button>                       
             </div>
            
            </div>
          </div>
        </div>
      </div>

      <div className="modal fade primary_modal toledbn" data-backdrop="static" id="Connet_w" tabIndex="-1" role="dialog" aria-labelledby="roi_modal" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header pt-1 mb-3 position">
              <h5 className="modal-title" id="Connet_w">Connect to a wallet</h5>
              <button type="button" className="close close_new" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
            <div className="wallet_panel_div">
                <div className="wallet_panel">
                  <h2>Metamask</h2>
                  <img src={require("../assets/images/metamask_icon.png")} className="mr-2" />
                  </div>                    
            </div>
            
            
            </div>
          </div>
        </div>
      </div>
      </div>
    </div>
  );
}
